// src/utils/request.js
import axios from 'axios'
import qs from 'qs'
import onlineUser from '../OnlineUser'
import Vue from 'vue'
import router from '@/router'
// axios实例
const service = axios.create({
  baseURL: process.env.API_ROOT,
  timeout: 150000
  // headers: {
  //   "Content-Type": "application/x-www-form-urlencoded"
  // }
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 添加 Token
    if (onlineUser.getToken()) {
      config.headers.Authorization = `Bearer ${onlineUser.getToken()}`
    }
    // 数据处理逻辑
    if (config.method === 'post') {
      const isMultipart = config.headers && config.headers['Content-Type'] === 'multipart/form-data'
      const isRaw = config.isRaw // 假设存在标识是否原生数据的配置

      if (!isMultipart && !isRaw) {
        // 包裹数组为对象，防止直接操作数组
        let rawData = config.data
        if (Array.isArray(rawData)) {
          rawData = { list: rawData } // 关键：数组包裹为对象字段
        }

        // 合并 lang 字段
        const dataWithLang = {
          ...rawData
        }

        // 序列化为表单格式，配置数组编码
        config.data = qs.stringify(dataWithLang, {
          arrayFormat: 'brackets', // 生成 list[]=1&list[]=2
          encode: true
        })
      }

      // 文件上传自动处理（若需启用）
      if (isMultipart) {
        const formData = new FormData()
        Object.entries(config.data).forEach(([key, value]) => {
          if (Array.isArray(value)) {
            value.forEach(item => formData.append(`${key}[]`, item))
          } else {
            formData.append(key, value)
          }
        })
        config.data = formData
      }
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    // Token 刷新机制
    if (response.headers.authorization) {
      onlineUser.setToken(response.headers.authorization)
    }

    const res =
      typeof response.data === 'object' || Array.isArray(response.data) ? response.data : JSON.parse(response.data)
    const resCode = res.code || res.status || response.status || null
    // 业务错误处理（根据你的接口规范调整）
    if (resCode) {
      // 成功码直接返回数据
      if ([200, 0].includes(resCode))
        return {
          code: resCode,
          message: res.msg || '成功',
          data: res.data || res || {}
        }
      // 错误码映射
      const errorMap = {
        401: { type: 'login', message: '登录已过期' },
        403: { type: 'permission', message: '权限不足' },
        400: { type: 'param', message: res.msg || '参数错误' },
        500: { type: 'server', message: res.msg||'服务器错误' }
      }
      const error = errorMap[resCode] || {
        type: 'unknown',
        message: res.msg || '未知错误'
      }

      return Promise.reject({
        ...error,
        code: res.code,
        res
      })
    }

    const otherError = {
      LOGIN_VALIDATE: { type: 'LOGIN_VALIDATE', message: '请登陆后重试' },
      PERMISSION_VALIDATE: { message: '你没有权限执行当前操作' },
      PARAM_VALIDATE: { message: '参数校验失败，请确认是否非法访问!' },
      TIME_OUT: { message: '连接超时，请重试!' }
    }
    const otherErrorItem = Object.keys(otherError).filter(key => res[key])
    if (otherErrorItem) {
      return Promise.reject({
        ...otherErrorItem,
        code: 999,
        res
      })
    }
    // 非标准格式直接返回
    return {
      code: resCode || 201,
      message: res.msg || '数据请求成功',
      data: res.data || res || {}
    }
  },
  error => {
    // 网络错误处理
    const errorInfo = {
      type: 'network',
      code: 'NETWORK_ERROR',
      message: '请求异常'
    }

    if (error.response) {
      // HTTP 状态码错误处理
      errorInfo.type = 'http'
      errorInfo.code = error.response.status
      errorInfo.message = `请求错误：${error.response.status}`
    }

    return Promise.reject(errorInfo)
  }
)
const request = async (url, data = {}, met = 'form', needGlobalHandle = true) => {
  const config = {
    headers: {},
    needGlobalHandle
  }

  // 根据 met 参数设置 Content-Type
  switch (met) {
    case 'image':
      config.headers['Content-Type'] = 'multipart/form-data'
      break
    case 'json':
      config.headers['Content-Type'] = 'application/json'
      config.isRaw = true // 标记为原生数据，避免拦截器处理
      break
    default:
      config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
  }
  const params = new URLSearchParams({ lang: localStorage.lang || "zh_CN" });
  const langUrl = `${url}?${params.toString()}`
  try {
    const res = await service.post(langUrl, data, config)
    return res
  } catch (error) {
    if (config.needGlobalHandle) handleGlobalError(error)
    return await Promise.reject(error)
  }
}

export default request

// 全局错误处理函数
function handleGlobalError(error) {
  const { type, message } = error
  if (type === 'LOGIN_VALIDATE') {
    sessionStorage.removeItem('MES_LOGIN_USER_BEAN')
    router.push({ path: '/login' })
  }
  console.error(error)
  if (message) {
    return Vue.prototype.$message({
      showClose: true,
      duration: 3000,
      message,
      type: 'error'
    })
  }
  Vue.prototype.$message.error('接口请求失败')
}
// export default service.post
// Vue 原型方法封装
// Vue.prototype.$post = function(url, data = {}, config = {}) {
//   return service.post(url, data, config)
//     .then(res => res)
//     .catch(error => {
//       // 全局错误处理（可选）
//       const needGlobalHandle = !config.skipGlobalError
//       if (needGlobalHandle) {
//         handleGlobalError(error)
//       }
//       return Promise.reject(error)
//     })
// }



// WEBPACK FOOTER //
// ./src/common/request/service.js